<template>
  <button
    v-if="isSnapQL"
    class="button is-small debug-button"
    title="Debug in SnapQL Debugger"
    @click="openExplorer">
    <span class="icon is-small">
      <i class="mdi mdi-code-tags" />
    </span>
  </button>
</template>
<script>

  export default {
    props: {
      dashboardModule: {
        type: Object,
        required: true,
      },
      dashboardDataContext: {
        type: Object,
        required: true,
      },
      dashboardKey: {
        type: String,
        required: true,
      },
    },
    computed: {
      isSnapQL () {
        return this.$hasFeatureFlag('USE_SNAPQL')
      },
    },
    methods: {
      openExplorer () {
        const baseUrl = this.$env.VUE_APP_VUE_3_CLIENT_URL
        const companyId = this.$route.params.company_id
        const params = new URLSearchParams({
          report: this.dashboardKey,
          module: this.dashboardModule.key,
        })
        const url = `${baseUrl}/company/${companyId}/tools/semantic_debug?${params.toString()}`
        window.open(url, '_blank')
      },
    },
  }
</script>
<style scoped lang="scss">
.debug-button {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin-right: 4px;
}
</style>
